function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sound from 'react-sound';
import CircularProgressBar from './circular-progress-bar';
var TonePlayer = /*#__PURE__*/function (_Component) {
  function TonePlayer(props) {
    var _this;
    _classCallCheck(this, TonePlayer);
    _this = _callSuper(this, TonePlayer, [props]);
    _this.state = {
      playStatus: Sound.status.PLAYING,
      position: 0,
      percentage: 0
    };
    _this.play = _this.play.bind(_this);
    _this.stop = _this.stop.bind(_this);
    _this.handleOnFinishedPlaying = _this.handleOnFinishedPlaying.bind(_this);
    _this.handleOnPlaying = _this.handleOnPlaying.bind(_this);
    return _this;
  }
  _inherits(TonePlayer, _Component);
  return _createClass(TonePlayer, [{
    key: "play",
    value: function play() {
      this.setState({
        position: 0,
        playStatus: Sound.status.PLAYING
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.setState({
        playStatus: Sound.status.STOPPED,
        position: 0,
        percentage: 0
      });
    }
  }, {
    key: "handleOnPlaying",
    value: function handleOnPlaying(_ref) {
      var position = _ref.position,
        duration = _ref.duration;
      var percentage = Math.floor(position) / duration * 100;
      this.setState({
        position: position,
        percentage: percentage
      });
      this.props.onPlaying({
        position: position,
        duration: duration
      });
    }
  }, {
    key: "handleOnFinishedPlaying",
    value: function handleOnFinishedPlaying() {
      this.setState({
        playStatus: Sound.status.STOPPED
      });
      this.props.onFinishedPlaying();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        soundFile = _this$props.soundFile,
        volume = _this$props.volume,
        controlsEnabled = _this$props.controlsEnabled;
      var _this$state = this.state,
        playStatus = _this$state.playStatus,
        position = _this$state.position,
        percentage = _this$state.percentage;
      return /*#__PURE__*/React.createElement("div", {
        className: "tone-player"
      }, /*#__PURE__*/React.createElement("div", {
        className: "circular-progress-bar__wrapper"
      }, /*#__PURE__*/React.createElement(CircularProgressBar, {
        sqSize: 60,
        percentage: percentage,
        strokeWidth: 2
      }), playStatus === Sound.status.PLAYING ? /*#__PURE__*/React.createElement("div", {
        role: "button",
        className: "tone-player__control tone-player__control--stop",
        onClick: function onClick() {
          return controlsEnabled && _this2.stop();
        },
        onKeyPress: function onKeyPress() {
          return controlsEnabled && _this2.stop();
        },
        tabIndex: "0"
      }) : /*#__PURE__*/React.createElement("div", {
        role: "button",
        className: "tone-player__control  tone-player__control--play",
        onClick: function onClick() {
          return controlsEnabled && _this2.play();
        },
        onKeyPress: function onKeyPress() {
          return controlsEnabled && _this2.play();
        },
        tabIndex: "0"
      })), playStatus === Sound.status.PLAYING && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Sound, {
        url: soundFile,
        playStatus: playStatus,
        position: position,
        volume: volume,
        onPlaying: this.handleOnPlaying,
        onFinishedPlaying: this.handleOnFinishedPlaying
      })));
    }
  }]);
}(Component);
TonePlayer.propTypes = {
  soundFile: PropTypes.string.isRequired,
  volume: PropTypes.number,
  onPlaying: PropTypes.func,
  onFinishedPlaying: PropTypes.func,
  controlsEnabled: PropTypes.bool
};
TonePlayer.defaultProps = {
  volume: 100,
  onPlaying: function onPlaying() {},
  onFinishedPlaying: function onFinishedPlaying() {},
  controlsEnabled: true
};
export default TonePlayer;